import * as React from 'react'

function SvgBell(props, svgRef) {
  return (
    <svg viewBox="0 0 21 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={svgRef} {...props}>
      <path d="M20.596 16.982c-.905-.973-2.6-2.437-2.6-7.232 0-3.642-2.553-6.558-5.997-7.273V1.5a1.5 1.5 0 10-2.998 0v.977c-3.443.715-5.997 3.63-5.997 7.273 0 4.795-1.695 6.26-2.6 7.232A1.465 1.465 0 000 18c.005.769.608 1.5 1.505 1.5h17.99c.897 0 1.5-.731 1.505-1.5a1.464 1.464 0 00-.404-1.018zm-17.43.268c.994-1.311 2.082-3.484 2.087-7.473 0-.01-.003-.018-.003-.027a5.25 5.25 0 1110.5 0c0 .01-.003.018-.003.027.005 3.99 1.093 6.162 2.087 7.473H3.166zM10.5 24a3 3 0 002.999-3H7.5a3 3 0 002.999 3z" />
    </svg>
  )
}

const ForwardRef = React.forwardRef(SvgBell)
export default ForwardRef
